import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HoverPopper } from "../../common/components/functional/hoverPopper/HoverPopper";

const TalentSearchInfo = () => {
  const { t } = useTranslation("common");

  return (
    <HoverPopper
      placement="top-start"
      paperSx={{
        width: 420,
        border: "none",
        borderRadius: "4px",
        backgroundColor: "#fff",
        px: 3,
        py: 2.5,
      }}
      trigger={
        <IconButton color="primary" aria-label="Info" size="medium">
          <InfoOutlinedIcon />
        </IconButton>
      }
    >
      <Typography variant="header" fontWeight={700} mb={1.5}>
        {t("sendEmailToTalentsInfoTitle")}
      </Typography>
      <Typography sx={{ whiteSpace: "pre-line" }}>
        {t("sendEmailToTalentsInfo")}
      </Typography>
    </HoverPopper>
  );
};

export default TalentSearchInfo;
